import 'babel-polyfill';
import ReactDOM from 'react-dom';
import React from 'react';
import App from 'app/app';
import 'assets/css/material-dashboard-react.css';
import 'app/myinsurance-unified.css';
import 'app/myinsurance-routes.js';
ReactDOM.render((       
    <App />
), document.getElementById('root'));

